const alltask = {
  ALLTASK: 'ALLTASK',
  ALLTASKPENDING: 'ALLTASKPENDING',
  ALLTASKPONGOING: 'ALLTASKPONGOING'
}
export { alltask }
